import React from 'react';
import PropTypes from 'prop-types';
import Recaptcha from 'react-recaptcha';
import identityConfig from '../../../config/identity';

import NewsletterListSection from './newsletter_list_section';
import SignupWidget from './email_input';
import StickySubmit from './sticky_submit';

function NewsletterSignupForm(props) {
  const {
    handleEmailUpdate,
    emailValue,
    disabled,
    handleSignupSubmit,
    placeholder,
    listsDictionary,
    sections,
    state,
    filter,
    transition,
    handleNewslettersUpdate,
    handleNewslettersRadioUpdate,
    hed,
    dek,
    buttonText,
    setFocus,
    toggleInputOn,
    emailFormError,
    emailUpdateSuccessMessage,
    emailUpdateMessageError,
    subscribedToIds,
    alreadyUsed,
    emailEditable,
    stickySubmit,
    handleStickySubmit,
    handleUnsubscribeAll,
    stickyMessage,
    handleVerify
  } = props;

  return (
    <div className="newsletter-form">
      <h2 className="newsletter-form__hed">{hed}</h2>
      <p className="newsletter-form__dek">{dek}</p>

      <form onSubmit={handleSignupSubmit}>
        <SignupWidget
          handleChange={handleEmailUpdate}
          value={emailValue}
          handleSubmit={handleSignupSubmit}
          disabled={disabled}
          placeholder={placeholder}
          buttonText={buttonText}
          setFocus={setFocus}
          toggleInputOn={toggleInputOn}
          emailFormError={emailFormError}
          emailUpdateSuccessMessage={emailUpdateSuccessMessage}
          emailUpdateMessageError={emailUpdateMessageError}
          emailEditable={emailEditable}
        />
        {handleVerify ? (
          <Recaptcha
            sitekey={identityConfig.fastcompany.reCaptcha.public}
            render="explicit"
            verifyCallback={handleVerify}
            onloadCallback={() => {}}
          />
        ) : (
          ''
        )}
        <div className="newsletter-form__groupings">
          {sections.map(section => (
            <NewsletterListSection
              {...{
                key: section.sectionTitle,
                sectionIds: section.ids,
                masterLookup: listsDictionary,
                state,
                sectionTitle: section.sectionTitle,
                filter,
                transition,
                subscribedToIds,
                alreadyUsed,
                handleChange: handleNewslettersUpdate,
                handleNewslettersRadioUpdate
              }}
            />
          ))}
        </div>
        {stickySubmit
          ? [
              <button
                className="newsletter-form__button newsletter-form__button--unsubscribe"
                type="button"
                onClick={handleUnsubscribeAll}
              >
                Unsubscribe from all
              </button>,
              <StickySubmit
                message={stickyMessage}
                handleSubmit={handleStickySubmit}
                handleUnsubscribeAll={handleUnsubscribeAll}
              />
            ]
          : null}
      </form>
    </div>
  );
}

NewsletterSignupForm.defaultProps = {
  filter: true,
  transition: true,
  disabled: false,
  placeholder: 'Your Email',
  buttonText: 'Send',
  setFocus: () => {},
  toggleInputOn: () => {},
  handleStickySubmit: () => {},
  handleUnsubscribeAll: () => {},
  emailFormError: '',
  emailUpdateSuccessMessage: '',
  emailUpdateMessageError: '',
  subscribedToIds: [],
  alreadyUsed: {},
  emailEditable: true,
  stickySubmit: false,
  stickyMessage: '',
  handleNewslettersRadioUpdate: () => {},
  handleVerify: false
};

NewsletterSignupForm.propTypes = {
  handleEmailUpdate: PropTypes.func.isRequired,
  emailValue: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  hed: PropTypes.string.isRequired,
  dek: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  handleSignupSubmit: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  listsDictionary: PropTypes.shape({}).isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  state: PropTypes.shape({}).isRequired,
  filter: PropTypes.bool,
  transition: PropTypes.bool,
  handleNewslettersUpdate: PropTypes.func.isRequired,
  setFocus: PropTypes.func,
  toggleInputOn: PropTypes.func,
  emailFormError: PropTypes.string,
  emailUpdateSuccessMessage: PropTypes.string,
  emailUpdateMessageError: PropTypes.string,
  subscribedToIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)])
  ),
  alreadyUsed: PropTypes.shape({}),
  emailEditable: PropTypes.bool,
  stickySubmit: PropTypes.bool,
  handleStickySubmit: PropTypes.func,
  handleUnsubscribeAll: PropTypes.func,
  stickyMessage: PropTypes.string,
  handleNewslettersRadioUpdate: PropTypes.func,
  handleVerify: PropTypes.func
};

export default NewsletterSignupForm;



// WEBPACK FOOTER //
// ./src/views/components/newsletters/newsletters_form.js